// components/Sidebar.js

import ElectionLive from "@/component/ElectionLive";
// import { useWindowSize } from "@/hooks/useIsMobile";
import { useEffect, useMemo, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { Fragment } from "react";

 
 
const AD_SHELL_STYLE = {
  width: "300px",
  height: "270px",          
  overflow: "hidden",         
  contain: "strict",         
  display: "block",
  flexShrink: 0,
};
 
const AdSlotDesktop300x250 = dynamic(
  () => import("@/component/Ads/AdSlotDesktop300x250"),
  {
    ssr: false,
    
  }
);

 
function AdSlotShell({ divId, visible = true }) {
  return (
    
    <div style={{ ...AD_SHELL_STYLE, visibility: visible ? "visible" : "hidden" }}>
      {visible && (
        <AdSlotDesktop300x250
          divId={divId}
          minWidth="300px"
          minHeight="250px"
        />
      )}
    </div>
  );
}

 

const LivePlayerCard = dynamic(() => import("../../LivePlayerCard"), {
 
  loading: () => <div style={{ height: "200px", width: "100%", contain: "strict" }} />,
  ssr: false,
});

const TrendingTopic = dynamic(() => import("./TrendingTopic"), {
  loading: () => <div style={{ height: "120px", width: "100%", contain: "strict" }} />,
  ssr: false,
});

const NewsList = dynamic(() => import("./NewsList"), {
 
  loading: () => <div style={{ height: "400px", width: "100%", contain: "strict" }} />,
  ssr: false,
});

const NewsList2 = dynamic(() => import("./NewsList2"), {
  loading: () => <div style={{ height: "400px", width: "100%", contain: "strict" }} />,
  ssr: false,
});

 
function NewsListSection({ isScroll, item, isRajasthan, isMadhya, isHR, isBH, isUP, isUK, className = "" }) {
  return (
    <section className={className}>
      <NewsList
        isScroll={isScroll}
        contentData={item[0]}
        isRajasthan={isRajasthan}
        isMadhya={isMadhya}
        isHR={isHR}
        isBH={isBH}
        isUP={isUP}
        isUK={isUK}
      />
    </section>
  );
}

export default function Sidebar({
  rightSideBarData = null,
  liveVideoData = null,
  topicListData = null,
  latestVideoData = null,
  latestStoryData = null,
  electionLiveData = null,
}) {
  const router = useRouter();
  const isRajasthan = router?.asPath?.includes("/rajasthan");
  const isMadhya = router?.asPath?.includes("/madhya-pradesh");
  const isHR = router?.asPath?.includes("/haryana");
  const isBH = router?.asPath?.includes("/bihar");
  const isUP = router?.asPath?.includes("/uttar-pradesh");
  const isUK = router?.asPath?.includes("/uttarakhand");

  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (!isScroll) setIsScroll(true);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isScroll]);

  const firstActive = useMemo(() => {
    let first = false;
    let firstActiveItem = "";
    electionLiveData?.content &&
      Object?.keys(electionLiveData?.content).forEach((key) => {
        if (!first && electionLiveData?.content?.[key]?.status === "1") {
          firstActiveItem = key;
          first = true;
        }
      });
    return firstActiveItem;
  }, [electionLiveData]);

  const regionProps = { isRajasthan, isMadhya, isHR, isBH, isUP, isUK };

  const hasLatestStory =
    latestStoryData?.content && latestStoryData.content.length > 0;

  return (
     
    <aside
      className="hidden md:block h-full right-0 min-h-screen border-l-[1px] px-2"
      style={{ willChange: "transform" }}
    >
      {liveVideoData?.live_id && (
        <LivePlayerCard liveData={liveVideoData} />
      )}

      <div
        className="top-layer-election"
        style={{ position: "sticky", contain: "layout" }}
      >
        <ElectionLive
          electionLiveData={electionLiveData?.content}
          firstActive={firstActive}
        />
      </div>

      {topicListData?.content?.length > 0 && (
        <TrendingTopic topicListData={topicListData} />
      )}

      
      <AdSlotShell
        divId="div-gpt-ad-1707804176041-1"
        visible={hasLatestStory || (!hasLatestStory && (rightSideBarData?.right?.length ?? 0) > 0)}
      />

      {hasLatestStory && (
        <section>
          <NewsList2
            isScroll={isScroll}
            contentData={latestStoryData}
            title="ट्रेंडिंग न्यूज़"
            {...regionProps}
          />
        </section>
      )}

      {latestVideoData?.content && (
        <div className="sticky top-[70px]" style={{ contain: "layout" }}>
          <NewsList2
            isScroll={isScroll}
            contentData={latestVideoData}
            title="ट्रेंडिंग वीडियो"
            {...regionProps}
          />
        </div>
      )}
      {rightSideBarData?.right?.map((item, index) => {
        const isLast = rightSideBarData.right.length === index + 1;
        const stickyClass = isLast ? "sticky top-[98px]" : "";

        return (
          <Fragment key={index}>
            {item[0]?.widget_name === "uptak_rhs_listing" &&
              item[0]?.content?.length > 0 && (
                <section
                  className={isLast ? "top-[70px]" : ""}
                  style={isLast ? { contain: "layout" } : undefined}
                >
                  
                  {isLast && (
                    <AdSlotShell
                      divId="div-gpt-ad-1751005897683-0"
                      visible={isScroll}
                    />
                  )}
                  <NewsList
                    isScroll={isScroll}
                    contentData={item[0]}
                    {...regionProps}
                  />
                  {isLast && (
                    <AdSlotShell
                      divId="div-gpt-ad-1751005897683-1"
                      visible={isScroll}
                    />
                  )}
                </section>
              )}

            {item[0]?.widget_name === "recommended_topics" &&
              item[0]?.content?.length > 0 && (
                <NewsListSection
                  isScroll={isScroll}
                  item={item}
                  className={stickyClass}
                  {...regionProps}
                />
              )}

            {item[0]?.widget_name === "recommended_story" &&
              item[0]?.content?.length > 0 && (
                <NewsListSection
                  isScroll={isScroll}
                  item={item}
                  className={stickyClass}
                  {...regionProps}
                />
              )}

            {item[0]?.widget_name === "recommended_video" &&
              item[0]?.content?.length > 0 && (
                <NewsListSection
                  isScroll={isScroll}
                  item={item}
                  className={stickyClass}
                  {...regionProps}
                />
              )}
          </Fragment>
        );
      })}
    </aside>
  );
}